import { useRef } from 'react';
import LinkForm from '../components/LinkForm.jsx';
import LinksList from '../components/LinksList.jsx';
import { useAuth } from '../hooks/useAuth.jsx';

export default function Home() {
  const { usuario, carregando } = useAuth();
  const recarregarRef = useRef(null);

  return (
    <div className="row gy-4">
      <div className="col-12">
        <h1 className="h3">Encurte um link em segundos</h1>
        <p className="text-secondary">Cole o endereço, dê um nome e pronto. Quem estiver logado vê todos os cliques.</p>
      </div>
      <div className="col-lg-6">
        <div className="card p-3">
          <LinkForm aoCriar={() => recarregarRef.current?.()} />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="card p-3">
          {carregando ? (
            <p className="text-secondary" aria-live="polite">Carregando…</p>
          ) : usuario ? (
            <LinksList recarregarRef={recarregarRef} />
          ) : (
            <section aria-labelledby="titulo-faca-login">
              <h2 id="titulo-faca-login" className="h4 mb-3">Faça login para acompanhar seus links</h2>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}
